const CM_IN_INCH = 2.54;
const KG_IN_LB = 0.45359237;

export { CM_IN_INCH, KG_IN_LB };
